import { getFormatter } from './formatter.js';

const validFormatStyles = ['decimal', 'percent', 'currency', 'currency-code', 'digital', 'digital-binary'];
const isFormatStyleValid = (style) => validFormatStyles.includes(style);
const isValueFalsy = (value) => !value && value !== 0;

export const formatNumber = (options = {}, value) => {
  const format = createFormatNumber(options);
  const isFactory = (value === undefined);

  return isFactory ? format : format(value);
};

const createFormatNumber = (options) => {
  const style = isFormatStyleValid(options.style) ? options.style : 'decimal';
  const precision = options.precision || 0;
  const humanize = options.humanize || '1';
  const currency = options.currency;
  const language = options.language;
  const trimFractionZeros = options.trimFractionZeros;

  const precisionLimits = getPrecisionLimits({ precision, trimFractionZeros });
  const formatter = getFormatter({ style, currency, precisionLimits });

  return (value) => {
    if (isValueFalsy(value)) {
      return '';
    }

    const { humanizedValue, abbreviation } = formatter.humanize(value, humanize, language);
    const formattedValue = formatter.format(humanizedValue);

    return formattedValue.includes('NaN') ? value : formattedValue + abbreviation;
  };
};

const getPrecisionLimits = ({ precision, trimFractionZeros }) => {
  if (isNaN(precision)) {
    return { min: 0, max: 0 };
  }

  if (precision === -1) {
    return { min: 0, max: 20 };
  }

  if (trimFractionZeros) {
    return { min: 0, max: precision };
  }

  return { min: precision, max: precision };
};
